export default {
  login ({ commit }, accessToken) {
    commit('CLEAR_REQUEST_TIME_CACHE')
    commit('CLEAR_RESPONSE_TIME_CACHE')

    commit('SET_ACCESS_TOKEN', accessToken)
  },
  logout ({ commit }) {
    commit('CLEAR_LAST_CHANGELOG_DISMISSED')
    commit('CLIENTS_CLEAR_ALL')
    commit('PROJECTS_CLEAR_ALL')
    commit('TASKS_CLEAR_ALL')
    commit('LOGS_CLEAR_ALL')
    commit('USERS_CLEAR_ALL')
    commit('FILTERS_CLEAR_ALL')
    commit('NOTIFICATIONS_CLEAR_ALL')
    commit('CLEAR_REQUEST_TIME_CACHE')
    commit('CLEAR_RESPONSE_TIME_CACHE')
    commit('CLEAR_ALL')
  },
  setPageTitle ({commit}, pageTitle) {
    commit('SET_PAGE_TITLE', pageTitle)
  },
  setCurrentRouteName ({commit}, currentRouteName) {
    commit('SET_CURRENT_ROUTE_NAME', currentRouteName)
  },
  setRequestTimestamp ({commit}, cacheItem) {
    commit('SET_REQUEST_TIME_CACHE_ITEM', cacheItem)
  },
  setResponseTimestamp ({commit}, cacheItem) {
    commit('SET_RESPONSE_TIME_CACHE_ITEM', cacheItem)
  },

  dismissChangelog ({commit}, version) {
    commit('SET_LAST_CHANGELOG_DISMISSED', version)
  },
  clearCache ({commit}) {
    commit('CLEAR_LAST_CHANGELOG_DISMISSED')
    commit('CLEAR_REQUEST_TIME_CACHE')
    commit('CLEAR_RESPONSE_TIME_CACHE')
    commit('CLIENTS_CLEAR_ALL')
    commit('PROJECTS_CLEAR_ALL')
    commit('TASKS_CLEAR_ALL')
    commit('LOGS_CLEAR_ALL')
    commit('USERS_CLEAR_ALL')
    commit('FILTERS_CLEAR_ALL')
    commit('NOTIFICATIONS_CLEAR_ALL')
  }
}
